import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/outbound/snapshots/:snapshotId");

export const Route = createFileRoute("/outbound/snapshots/$snapshotId")({
  head: () => ({
    meta: [
      { title: "Outbound snapshot — LevelLoad" },
      { name: "description", content: "Outbound snapshot — LevelLoad transport planning." },
      { property: "og:title", content: "Outbound snapshot — LevelLoad" },
      { property: "og:description", content: "Outbound snapshot — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
